import {Flex} from 'exsportia-components'
import {FC} from 'react'

import {LegalFooter} from '../../components/legal/legal-footer'
import {useLegalLang} from '../../components/legal/use-legal-lang'

// Legal footer of every venue page (also sign-in, sign-up, checkout: those are opened over these pages):
// Privacy · Terms · Data deletion, then the company line of Education AI Group Co., Ltd. (the version is in the profile menu)
export const PreFooter: FC = () => {
  const lang = useLegalLang()
  return (
    <Flex
      backgroundColor={'bg'}
      pt='8px'
      width='100%'
      flexDirection='column'
    >
      <LegalFooter lang={lang} />
    </Flex>
  )
}
